import React from 'react';
import { Box, Flex, Text, Button, Image, Stack, Divider } from '@chakra-ui/react';
import { MessageCircle, Instagram, Youtube, Heart } from 'lucide-react';
export const Footer: React.FC = () => {
  return <Box bg="gray.900" color="white" pt={10} pb={28} px={5} data-id="element-24">
      <Stack spacing={8} maxW="480px" mx="auto" data-id="element-25">
        {/* Customer Care */}
        <Box className="animate-slide-up" data-id="element-26">
          <Text fontSize="md" fontWeight="700" mb={4} letterSpacing="0.02em" data-id="element-27">
            📞 Customer Care
          </Text>
          <Button as="a" href="https://chat.whatsapp.com/IkRgOt1lq4OGk2v9SDVqYa?mode=gi_t" target="_blank" rel="noopener noreferrer" bg="green.500" color="white" _hover={{
          bg: 'green.600',
          transform: 'translateY(-2px)'
        }} leftIcon={<MessageCircle size={18} data-id="element-29" />} w="full" justifyContent="flex-start" size="lg" borderRadius="12px" transition="all 0.3s ease" shadow="md" data-id="element-28">
            Join WhatsApp Group
          </Button>
        </Box>

        <Divider borderColor="gray.700" data-id="element-30" />

        {/* Follow Us */}
        <Box data-id="element-31">
          <Text fontSize="md" fontWeight="700" mb={4} letterSpacing="0.02em" data-id="element-32">
            📱 Follow Us
          </Text>
          <Stack spacing={3} data-id="element-33">
            <Button as="a" href="https://www.instagram.com/skybrand.yourbelive?igsh=MXQzeTRzeW5icHQyYg==" target="_blank" rel="noopener noreferrer" bgGradient="linear(to-r, #833AB4, #FD1D1D, #F77737)" color="white" _hover={{
            opacity: 0.9,
            transform: 'translateY(-2px)'
          }} leftIcon={<Instagram size={18} data-id="element-35" />} w="full" justifyContent="flex-start" borderRadius="12px" transition="all 0.3s ease" shadow="md" data-id="element-34">
              Follow on Instagram
            </Button>
            <Button as="a" href="https://youtube.com/@skybrand_12?si=gbLTwnUZ-TgmycEB" target="_blank" rel="noopener noreferrer" bg="red.600" color="white" _hover={{
            bg: 'red.700',
            transform: 'translateY(-2px)'
          }} leftIcon={<Youtube size={18} data-id="element-37" />} w="full" justifyContent="flex-start" borderRadius="12px" transition="all 0.3s ease" shadow="md" data-id="element-36">
              Subscribe on YouTube
            </Button>
          </Stack>
        </Box>

        <Divider borderColor="gray.700" data-id="element-38" />

        {/* Brand Info */}
        <Flex direction="column" align="center" textAlign="center" pt={4} data-id="element-39">
          <Image src="https://cdn.magicpatterns.com/uploads/cNqMS3US7kkJPPcN3Awd9h/1000066978.png" alt="Sky Brand" h="50px" mb={4} className="animate-float" data-id="element-40" />
          <Text fontWeight="700" fontSize="md" mb={1} letterSpacing="0.02em" data-id="element-41">
            Sky Brand – Your Style, Your Belief
          </Text>
          <Text color="gray.400" fontSize="xs" mb={1} data-id="element-42">
            Premium Clothing · Ghazipur Exclusive
          </Text>
          <Flex align="center" gap={1} mt={3} data-id="element-43">
            <Text color="gray.500" fontSize="xs" data-id="element-44">
              Made with
            </Text>
            <Heart size={12} fill="red" color="red" data-id="element-45" />
            <Text color="gray.500" fontSize="xs" data-id="element-46">
              in India
            </Text>
          </Flex>
          <Text color="gray.600" fontSize="10px" mt={2} data-id="element-47">
            © 2024 Sky Brand. All rights reserved.
          </Text>
        </Flex>
      </Stack>
    </Box>;
};